import { useEffect, useState } from 'react';
import * as publicApi from '../api/publicClient';

export function useCategories(hub) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    publicApi.getCategories(hub)
      .then((data) => { if (!cancelled) setCategories(data); })
      .catch(() => { if (!cancelled) setCategories([]); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [hub]);

  return { categories, loading };
}